import React from 'react';
import { ArrowRight } from 'lucide-react';
import { brandData } from '../mock';

// Compact hero-top comparison (Before -> Now)
export default function HeroComparison() {
  return (
    <div className="flex items-start justify-center gap-6 md:gap-12 lg:gap-16 mb-10 md:mb-14 animate-fade-up delay-1">
      {/* Before */}
      <div className="flex flex-col items-center">
        <div className="text-[10px] tracking-[0.28em] uppercase text-[#EA580C] mb-4">Before</div>
        <div className="w-20 h-20 md:w-24 md:h-24 rounded-md bg-white border border-black/5 overflow-hidden flex items-center justify-center shadow-sm">
          <img
            src={brandData.before.logo}
            alt="Confidential logo"
            className="w-full h-full object-contain p-2"
          />
        </div>
        <div className="mt-4 text-[15px] md:text-base font-serif text-neutral-900">Confidential</div>
      </div>

      {/* Arrow */}
      <div className="flex flex-col items-center pt-8 md:pt-10">
        <div className="flex items-center gap-2">
          <div className="h-px w-10 md:w-14 bg-[#EA580C]/60" />
          <ArrowRight className="w-4 h-4 text-[#EA580C]" />
        </div>
        <div className="mt-2 text-[11px] italic text-neutral-500 font-serif">is now</div>
      </div>

      {/* Now */}
      <div className="flex flex-col items-center">
        <div className="text-[10px] tracking-[0.28em] uppercase text-[#EA580C] mb-4">Now</div>
        <div className="w-20 h-20 md:w-24 md:h-24 rounded-md bg-neutral-950 overflow-hidden flex items-center justify-center shadow-sm">
          <img
            src={brandData.now.logo}
            alt="Startup Culture logo"
            className="w-full h-full object-contain"
          />
        </div>
        <div className="mt-4 text-[15px] md:text-base font-serif text-neutral-900">Startup Culture</div>
      </div>
    </div>
  );
}
